import React from 'react';

const containerStyle = {
  maxWidth: 860,
  margin: '0 auto',
  padding: '40px 20px 64px',
  color: '#1f2937',
  lineHeight: 1.6
};

const PrivacyPolicy = () => {
  return (
    <main style={containerStyle}>
      <h1 style={{ fontSize: 32, marginBottom: 8 }}>Privacy Policy</h1>
      <p style={{ color: '#6b7280', marginBottom: 24 }}>Last updated: May 8, 2026</p>

      <p>
        Accurate Lien Searches (&quot;we&quot;, &quot;us&quot;, &quot;our&quot;) uses QuickBooks data only to provide operational features inside our
        application.
      </p>

      <h2 style={{ fontSize: 22, marginTop: 28 }}>Information We Access</h2>
      <p>
        When you connect QuickBooks, we may access accounting records required to calculate and sync order hard costs
        (for example purchases, project/customer references, and related metadata).
      </p>

      <h2 style={{ fontSize: 22, marginTop: 28 }}>How We Use Information</h2>
      <ul>
        <li>Authenticate your QuickBooks connection via OAuth.</li>
        <li>Query approved QuickBooks endpoints to sync hard-cost values.</li>
        <li>Store synced hard-cost values in our internal order records.</li>
      </ul>

      <h2 style={{ fontSize: 22, marginTop: 28 }}>Data Storage</h2>
      <p>
        We store access credentials/tokens needed for authorized API calls and store only business data required for
        our service workflows.
      </p>

      <h2 style={{ fontSize: 22, marginTop: 28 }}>Data Sharing</h2>
      <p>
        We do not sell personal data. We only share data with service providers as needed to operate our platform or
        when required by law.
      </p>

      <h2 style={{ fontSize: 22, marginTop: 28 }}>Your Choices</h2>
      <p>You can disconnect QuickBooks at any time by removing app authorization in QuickBooks.</p>

      <h2 style={{ fontSize: 22, marginTop: 28 }}>Contact</h2>
      <p>For privacy requests, contact: info@accurateliensearch.net</p>
    </main>
  );
};

export default PrivacyPolicy;
